export default __webpack_public_path__ + "static/media/0016.f69af8c6.jpg";